import { useTranslation } from "react-i18next";
import { SessionSystemLine } from "../../features/messages/models/SessionSystemLine";
import { systemLineText } from "../../features/messages/utils/systemLineText";

interface SystemLineProps {
  line: SessionSystemLine;
  /** The Session's name, as the thread's title shows it. */
  sessionName: string;
}

/** A schedule fact in a Session thread: muted, centred, no author; in the reader's language and zone. */
const SystemLine = ({ line, sessionName }: SystemLineProps) => {
  const { t, i18n } = useTranslation();
  return (
    <li className="py-2 text-center text-xs text-grey-40 dark:text-grey-80" data-testid="system-line">
      {systemLineText(line, sessionName, t, i18n.language)}
    </li>
  );
};

export default SystemLine;
